'use client'

import { cn } from '../../lib'
import type { ChipV3Props } from './chip-v3.types'

import { chipV3Style } from './chip-v3.css'

const ChipV3 = ({ className, children, selected, fontWeight = 'bold', direction, ...props }: ChipV3Props) => {
  return (
    <button
      {...props}
      className={cn([`font-${fontWeight}`, 'tracking-[-0.7px]'], chipV3Style({ direction }), className)}
      data-selected={selected ? 'selected' : 'un-selected'}
      aria-selected={selected}
    >
      {children}
    </button>
  )
}

ChipV3.displayName = 'ChipV3'

export default ChipV3
